import { render, staticRenderFns } from "./facility-contract-template.html?vue&type=template&id=b8b4f556&scoped=true&external"
import script from "./facility-contract-template.js?vue&type=script&lang=js&external"
export * from "./facility-contract-template.js?vue&type=script&lang=js&external"
import style0 from "./facility-contract-template.scss?vue&type=style&index=0&id=b8b4f556&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b4f556",
  null
  
)

export default component.exports